//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'

import { OpDescr } from './op-descr'

export class OpUnit implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idUnit: number
    public bias: number
    public name: string
    public scale: number
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any = null) {
       this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdUnit
    }
    public getReferenceKey(): number {
        return this.idUnit
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idUnit = opObj.I
                this.bias = opObj.B
                this.name = opObj.N
                this.scale = opObj.S
                this.idDescr = opObj.ID
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O

            } else {

                this.idUnit = opObj.ID_UNIT
                this.bias = opObj.BIAS
                this.name = opObj.NAME
                this.scale = opObj.SCALE
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState

            }
        }

    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                I: this.idUnit,
                B: this.bias,
                N: this.name,
                S: this.scale,
                ID: this.idDescr,
                D: this.descr ? this.descr.toJSON() : null,
                O: this.opState,

                __IC: 1

            }
        } else {
            return {
                ID_UNIT: this.idUnit,
                BIAS: this.bias,
                NAME: this.name,
                SCALE: this.scale,
                ID_DESCR: this.idDescr,
                _Descr: this.descr ? this.descr.toJSON() : null,
                OpState: this.opState
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpUnit[]): JQueryPromise<OpUnit[]> {
        var defered = $.Deferred<OpUnit[]>()

        defered.resolve(list)

        return defered.promise()
    }

    // Restore methods
    public static restore(restoredOpObj: OpUnit) {
        if (restoredOpObj) {
            var opObj = new OpUnit()
            opObj.idUnit = restoredOpObj.idUnit
            opObj.bias = restoredOpObj.bias
            opObj.name = restoredOpObj.name
            opObj.scale = restoredOpObj.scale
            opObj.idDescr = restoredOpObj.idDescr
            opObj.descr = OpDescr.restore(restoredOpObj.descr)
            opObj.opState = restoredOpObj.opState
            return opObj
        }
        return null
    }
}